import React from 'react';
import { useQuery, Loading, Error } from 'react-admin';
import jwt_decode from 'jwt-decode'


const Namechoices = ({...props}) => {
    let cid = ((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).cid : '1'    
    //console.log(cid)
    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: 'trainingchoiceset',
        payload: { id: cid }
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    //console.log(data)
    let names = [];
    let freqs = [];
    var trainings = (data.trainings)? JSON.parse(data.trainings): null;
    trainings.map((item, index) => {
        
        item.isActive && names.push(
            {
                id : item['name'] + ',' + item['frequency'],
                name: item['name'],
            }
        )

    })

    props && props.setChoices &&  props.setChoices(names)
    return (<div></div>)
};

export default Namechoices